"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'IceLabel',
  props: {
    name: String,
    width: {
      type: Number,
      default: 100
    },
    required: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'left' // left,top
    },
    needValid: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      errorMsg: '',
      errorClass: false
    };
  },
  methods: {
    fireErrorMsg: function fireErrorMsg(msg) {
      this.clearError();
      this.errorMsg = msg;
      this.errorClass = true;
    },
    clearError: function clearError() {
      this.errorMsg = '';
      this.errorClass = false;
    }
  },
  computed: {
    labelAreaStyle: function labelAreaStyle() {
      var style = {};
      if (this.position == 'top') {
        style.flexDirection = 'column';
      } else {
        style.flexDirection = 'row';
      }
      if (this.needValid) {
        style.marginBottom = '16px';
      } else {
        style.marginBottom = '5px';
      }
      return style;
    },
    contentWidth: function contentWidth() {
      return this.position == 'top' ? '280px' : '200px';
    },
    labelStyle: function labelStyle() {
      var style = {};
      if (this.position == 'top') {
        style.textAlign = 'left';
        style.width = '100%';
        style.marginBottom = '6px';
      } else {
        style.width = this.width + 'px';
      }
      return style;
    }
  },
  watch: {},
  mounted: function mounted() {},
  components: {}
};